export enum Series {
  Series3 = 'Series 3/3+',
  Series2 = 'Series 2',
}

export type SeriesAbbrev = 'S1' | 'S2' | 'S3';
